import Object from './object.js'

export default class ObjectText extends Object {

}